import { Typography } from "@material-ui/core"

export const DesignSystem = (mode) => ({
  scrollbarStyles: {
    "&::-webkit-scrollbar": {
      width: "8px",
      height: "8px",
    },
    "&::-webkit-scrollbar-thumb": {
      borderRadius: "12px !important",
      backgroundColor: "#999",
    },
  },
  scrollbarStylesSoft: {
    "&::-webkit-scrollbar": {
      width: "8px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: mode === "light" ? "#585757" : "#333333",
    },
  },
  ListItemLink: {
    paddingTop: "50px",
    paddingBottom: "50px",
  },
  radius: {
    radius100: "0px",
    radius200: "4px",
    radius300: "12px",
    radius400: "100px",
  },
  espacamento: {
    spacing100: "2px",
    spacing200: "4px",
    spacing300: "8px",
    spacing400: "16px",
    spacing500: "24px",
    spacing600: "32px",
    spacing700: "40px",
    spacing800: "48px",
    spacing900: "56px",
  },
  elevation: {
    elevation100: "0px 1px 4prgba(0, 0, 0, 0.1)",
    elevation200: "0px 4px 6px rgba(0, 0, 0, 0.1)",
    elevation300: "0px 8px 12px rgba(0, 0, 0, 0.1)",
  },
  palette: {
    type: mode,
    primary: { main: mode === "light" ? "#009FFD" : "#FFFFFF" },
    textPrimary: mode === "light" ? "#009FFD" : "#FFFFFF",
    borderPrimary: mode === "light" ? "#009FFD" : "#FFFFFF",
    dark: { main: mode === "light" ? "#333333" : "#F3F3F3" },
    light: { main: mode === "light" ? "#F3F3F3" : "#333333" },
    tabHeaderBackground: mode === "light" ? "#EEE" : "#666",
    optionsBackground: mode === "light" ? "#FFFFFF" : "#333",
    options: mode === "light" ? "#FFFFFF" : "#666",
    fontecor: mode === "light" ? "#128c7e" : "#fff",
    fancyBackground: mode === "light" ? "#FFFFFF" : "#333",
    bordabox: mode === "light" ? "#eee" : "#333",
    newmessagebox: mode === "light" ? "#eee" : "#333",
    inputdigita: mode === "light" ? "#fff" : "#666",
    contactdrawer: mode === "light" ? "#fff" : "#666",
    announcements: mode === "light" ? "#ededed" : "#333",
    loginBackground: "#fff",
    loginButtonBackground: "#009FFD",
    loginButtonText: "#FFFFFF",
    announcementspopover: mode === "light" ? "#fff" : "#666",
    chatlist: mode === "light" ? "#eee" : "#666",
    boxlist: mode === "light" ? "#ededed" : "#666",
    boxchatlist: mode === "light" ? "#ededed" : "#333",
    total: mode === "light" ? "#fff" : "#222",
    messageIcons: mode === "light" ? "grey" : "#F3F3F3",
    inputBackground: mode === "light" ? "#FFFFFF" : "#333",
    barraSuperior: mode === "light" ? "#FFFFFF" : "#333",
    boxticket: mode === "light" ? "#EEE" : "#666",
    campaigntab: mode === "light" ? "#ededed" : "#666",
    mediainput: mode === "light" ? "#ededed" : "#1c1c1c",
    buttonBackground: mode === "light" ? "#009FFD" : "#FFFFFF",
    buttonColor: mode === "light" ? "#FFFFFF" : "#333333",
    colorReverse: mode === "light" ? "#E4E4E4" : "#FFFFFF",
    colorReverseGrey: mode === "light" ? "#585757" : "#FFFFFF",
    colorReverseBlack: mode === "light" ? "#333333" : "#FFFFFF",
    buttonColorReverseFilter:
      mode === "light"
        ? "invert(0%) sepia(0%) saturate(0%) hue-rotate(0deg)"
        : "invert(100%) sepia(0%) saturate(100%) hue-rotate(0deg)",
    appBackground: mode === "light" ? "#F4F4F4" : "#424242",
    elementBar: mode === "light" ? "#585757" : "white",
    menuBackground: mode === "light" ? "#F4F4F4" : "#585757",
    borderColorBar: mode === "light" ? "#E7E7E7" : "#585757",
    borderColorMenu: mode === "light" ? "#E7E7E7" : "#FFFFFF",
    ColorCircle: mode === "light" ? "#F4F4F4" : "#FFFFFF",
    ColorCircleSecondary: mode === "light" ? "#F4F4F4" : "#FFFFFF",
    borderColorCircle: mode === "light" ? "#d6d6d6" : "#595959",
    ticketsBackground: mode === "light" ? "#F4F4F4" : "#424242",
    inputMessageTicket: mode === "light" ? "#F4F4F4" : "#FFFFFF",

    neutral100: mode === "light" ? "#FFFFFF" : "#FFFFFF",
    neutral200: mode === "light" ? "#E7E7E7" : "#2E2D2A",
    neutral300: mode === "light" ? "#969696" : "#575653",
    neutral400: mode === "light" ? "#585757" : "#8E8E8C",
    neutral500: mode === "light" ? "#1C1C1C" : "#D1D1D1",

    primary100: mode === "light" ? "#80CFFE" : "#8DD4FE",
    primary200: mode === "light" ? "#009FFD" : "#19A9FD",
    primary300: mode === "light" ? "#006FB1" : "#197DB9",
    primary400: mode === "light" ? "#1B315F" : "#32466F",

    feedbackInfo100: mode === "light" ? "#2391E1" : "#4FA7E7",
    feedbackInfo200: mode === "light" ? "#1B6AA3" : "#7BBDED",

    feedbackSuccess100: mode === "light" ? "#029C49" : "#35B06D",
    feedbackSuccess200: mode === "light" ? "#016D33" : "#67C492",

    feedbackWarning100: mode === "light" ? "#DF8F16" : "#E5A545",
    feedbackWarning200: mode === "light" ? "#9C640F" : "#ECBC73",

    feedbackError100: mode === "light" ? "#F14444" : "#F46969",
    feedbackError200: mode === "light" ? "#A93030" : "#F78F8F",

    background100: mode === "light" ? "#FFFFFF" : "#262626",
    background200: mode === "light" ? "#F4F4F4" : "#1C1C1C",
    background300: mode === "light" ? "#EDF8FF" : "#1B2327",

    backgroundInfo: mode === "light" ? "#E9F4FC" : "#212A30",
    backgroundSuccess: mode === "light" ? "#E6F5ED" : "#1F2B24",
    backgroundWarning: mode === "light" ? "#FCF4E8" : "#302A20",
    backgroundError: mode === "light" ? "#FEECEC" : "#322424",

    complementaryTeal100: mode === "light" ? "#22BCBF" : "#69D1D4",
    complementaryPurple100: mode === "light" ? "#874FFF" : "#AD87FF",
    complementaryPink100: mode === "light" ? "#F849C1" : "#FA83D5",
    complementaryBrown100: mode === "light" ? "#CB4806" : "#D56D38",
  },
  mode,
})
